import { readSettings } from './settings-fields';

/** `GET /client/:cid` (merged settings) in cb's `/settings` shape. */
export const getSettings = async (): Promise<any> => readSettings();
